<template>
  <div class="text-gray-700">
    <label class="block mb-1 required text-gray-smoke font-medium text-sm md:text-lg mb-2" v-if="header">Language </label>
    <select
      ref="becomeLanguages"
      class="form-select text-gray-slate w-full pl-3 pr-3 h-10 md:h-12 border-1 border-borderColor focus:outline-none rounded-md"
      v-model="$v.languageId.$model"
      @change="languagesChange"
    >
      <option value="none" disabled>Choose your languages</option>
      <option :selected="l.id === 1" :value="l.id" v-for="l in languagesList" :key="l.id">
        {{ l.language }}
      </option>
    </select>
    <div class="mt-2 flex flex-wrap">
      <span
        class="mr-2 mb-2 rounded-lg focus:outline-none"
        v-for="l in languagesData"
        :class="[ selectedLanguageClass ? selectedLanguageClass : 'bg-green-light px-4 py-1 text-white' ]"
        :key="l.id"
      >
        <span class="text-sm">{{ l.text }}</span>
        <button type="button" class="ml-2" @click="languagesRemove(l.id)">
          X
        </button>
      </span>
    </div>
    <div v-if="!$v.languagesData.required">
      <span class="text-xs text-red-700"> Language is required </span>
    </div>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";

export default {
  name: "LanguageInput",
  props: {
    languagesList: {
      type: [Array, Object],
    },
    languagesData: {
      type: Array,
      default: [],
    },
    languages: {
      type: [Array, String, Number],
    },
    languageStyle: {
      type: String,
    },
    header: {
      type: Boolean,
      default: true,
    },
    selectedLanguageClass: {
      type: String,
    },
    defLanguage: {
      type: Boolean
    }
  },
  validations: {
    languagesData: {
      required,
    },
    languages: {
      required,
    },
    languageId: {
      required,
    },
  },
  data() {
    return {};
  },
  computed: {
    languageId: {
      // getter
      get: function () {
        return this.languages;
      },
      // setter
      set: function () {},
    },
    getDefaultLanguage () {
      return this.languagesList && this.languagesList.length && this.languagesList.find((itm) => itm.code === 'en')
    }
  },
  methods: {
    languagesChange(event) {
      this.$emit("LanguagesChange", event);
    },
    languagesRemove(id) {
      this.$emit("LanguagesRemove", id);
    },
  },
  mounted () {
    if (this.defLanguage && this.getDefaultLanguage && Object.keys(this.getDefaultLanguage).length) {
      this.languageId = this.getDefaultLanguage.id
      const index = this.languagesList.findIndex(obj => obj.id === this.getDefaultLanguage.id);
      let elem = this.$refs.becomeLanguages
      elem.selectedIndex = index + 1
      this.languagesChange({
        target: {
          value: this.getDefaultLanguage.id,
          options: elem.options
        }
      })
    }
  }
};
</script>